export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zgłoszenie do wsparcia technicznego"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["od"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czat"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj wiadomość"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pliki"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Możesz przesłać jeden lub więcej plików. Maksymalny rozmiar pliku to 10 MB."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Treść wiadomości"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyślij"])}
}